module.exports = __webpack_public_path__ + "img/whatsapp-icon.936048da.svg";